export const DirectLoginFonts = [
  { name: 'adevinta', font: 'dmsans' },
  // { name: 'ball', font: 'lato-semibold-webfont' },
  // { name: 'franklinelectric', font: 'Gotham XNarrow Light' },
  // { name: 'nike', font: 'TradeGothic-BoldCondTwenty' },
  // { name: 'nokia', font: 'NokiaKokia' },
  // { name: 'nokia_nep', font: 'NokiaKokia' },
  //{ name: 'razer', font: 'RazerF5Light' },
  { name: 'starsgroup', font: 'roboto' },
  { name: 'unither', font: 'oxygen-bold' },
  { name: 'validus', font: 'Univers-light-normal' },
];

export const DirectLoginStateOption = ['alphabet'];
